// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__28cy6","sendOtp":"AuthorizeToLogin_sendOtp__32w9N"};